import { useEffect } from 'react';

export interface UseSensorDataRegistrationProps {
  registerSensorData?: (
    dataLayer: string,
    enabledSensors: Record<string, boolean>,
    sensorColors: Record<string, string>
  ) => void;
  dataLayer: string | undefined;
  enabledSensors: Record<string, Record<string, boolean>>;
  data: Record<string, any>;
}

/**
 * Registers sensor data for external components (like search filters)
 * Combines enabled sensors and colors from all sections and registers them
 */
export function useSensorDataRegistration({
  registerSensorData,
  dataLayer,
  enabledSensors,
  data,
}: UseSensorDataRegistrationProps): void {
  useEffect(() => {
    if (registerSensorData && dataLayer && enabledSensors && data) {
      // Combine all enabled sensors from all sections in this data layer
      const combinedEnabledSensors: Record<string, boolean> = {};
      const combinedSensorColors: Record<string, string> = {};

      Object.values(enabledSensors).forEach((sectionSensors) => {
        Object.assign(combinedEnabledSensors, sectionSensors);
      });

      // Get sensor colors from the data
      Object.values(data || {}).forEach((sectionData) => {
        sectionData?.forEach?.((sensor: any) => {
          const sensorName = sensor.displayName || sensor.name;
          if (sensorName && sensor.color) {
            combinedSensorColors[sensorName] = sensor.color;
          }
        });
      });

      registerSensorData(dataLayer, combinedEnabledSensors, combinedSensorColors);
    }
  }, [registerSensorData, dataLayer, enabledSensors, data]);
}
